module.exports = __webpack_public_path__ + "default@2x.ce86307f9d783efd37af35b190bb3642.png";